export default __webpack_public_path__ + "static/media/up-detr.b2cd2197.png";